var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.9457 10.0002C19.9457 15.494 15.4923 19.9476 9.99855 19.9476C4.50477 19.9476 0.051239 15.494 0.051239 10.0002C0.051239 4.50647 4.50477 0.0529327 9.99855 0.0529327C15.4922 0.0529327 19.9457 4.50647 19.9457 10.0002",
    fill: "#505050"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96674 5.38461L9.9053 5.59345V11.6533L9.96674 11.7146L12.7797 10.0519L9.96674 5.38461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96675 5.38461L7.15384 10.0519L9.96675 11.7146V8.77338V5.38461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96672 12.6298L9.9321 12.672V14.8307L9.96672 14.9318L12.7813 10.9679L9.96672 12.6298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96675 14.9318V12.6298L7.15384 10.9679L9.96675 14.9318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96674 11.7146L12.7796 10.0519L9.96674 8.77341V11.7146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15384 10.0519L9.96671 11.7146V8.77338L7.15384 10.0519Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.37fb3a237719070195713f345f83efe2.svg";
export { ForwardRef as ReactComponent };